var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Application Logs")]),_c('hr'),_c('LogsTable',{attrs:{"loading":_vm.loading,"logs":_vm.logs,"totalLogs":_vm.totalLogs},on:{"removeAll":_vm.removeAll,"page:changed":_vm.getNewPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }